import { render, staticRenderFns } from "./ContactsInput.vue?vue&type=template&id=b03dcafc&scoped=true&"
import script from "./ContactsInput.vue?vue&type=script&lang=js&"
export * from "./ContactsInput.vue?vue&type=script&lang=js&"
import style0 from "./ContactsInput.vue?vue&type=style&index=0&id=b03dcafc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03dcafc",
  null
  
)

export default component.exports